<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col md:w-2/12 w-full">
        <h6 class="mb-2">Sigla</h6>
        <v-select name="sigla" :options="initials" v-validate="'required'" v-model="data.sigla">
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Nenhuma sigla encontrada</em>
          </template>
        </v-select>
        <span class="text-danger text-sm" v-show="errors.has('sigla')">{{ errors.first('sigla') }}</span>
      </div>
      <div class="vx-col md:w-10/12 w-full">
        <h6 class="mb-2">Descrição</h6>
        <vs-input name="descricao" v-uppercase v-validate="'required'" v-model="data.descricao" class="w-full"></vs-input>
        <span class="text-danger text-sm" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
      </div>
    </div>
    <div class="flex flex-wrap items-center" slot="footer">
      <vs-button class="mr-6" @click="submitData()">Salvar</vs-button>
    </div>
  </vx-card>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from "@/global"
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    sigla: { required: 'Selecione uma sigla' },
    descricao: { required: 'Digite a descrição' },
  }
};

Validator.localize('en', dict);

export default {
  data() {
    return {
      initials: [],
      data: {}
    }
  },
  methods: {
    async loadInitialsWithoutDescription() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/descriptions`, { params: { initialsWithoutDescription: true } });
        this.initials = response.data
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async submitData() {
      const haveErrors = !(await this.$validator.validateAll())
      if (haveErrors)
        return

      try {
        this.$vs.loading();
        const response = await axios.post(`${baseApiUrl}/descriptions`, this.data);
        this.$vs.notify({
          color: 'success',
          title: 'Criado',
          text: `Descrição criada com successo.`
        })
        this.$router.push({ name: 'importation-description-list' })
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar: " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }

    }
  },
  async created() {
    await this.loadInitialsWithoutDescription()
  }
}

</script>
